import RcPagination, { PaginationProps } from 'rc-pagination';

import Item, { TItemType } from './Item';

import './pagination.scss';

const Pagination = (props: PaginationProps) => {
  return (
    <RcPagination
      {...props}
      className='pagination'
      itemRender={(page, type) => (
        <Item page={page} type={type as TItemType} isActive={props?.current === page} />
      )}
    />
  );
};

export default Pagination;
